export const verbiage = {
  // SELECT FULFILLMENT
  SELECT_FULFILLMENT_TITLE: 'Which type of gift card do you want to send?',
  EMAIL_TILE: 'Digital',
  EMAIL_SUBTITLE: 'Send it instantly or on a specific date for free.',
  EMAIL_FOOTER: '(Select date/time during checkout)',
  SHIP_TITLE: 'Physical',
  SHIP_SUBTITLE:
    'Send a traditional gift card through the mail. Flexible shipping options available.',
  SHIP_FOOTER: '(Select shipping during checkout)',
  USE_A_SET_AMOUNT: 'Use a Set Amount',
  ENTER_A_CUSTOM_AMOUNT: 'Enter a Custom Amount',
  WHO_IS_THIS_FOR: 'Who is this for?',
  SELECT_AMOUNT: 'Select Amount'
};

export const error = {
  technicalError: 'Sorry, we\'re experiencing technical difficulties. Please try again later.'
};

export const fulfillments = {
  EMAIL_IT: 'DIGITAL',
  DIGITAL: 'DIGITAL',
  SHIP_IT: 'PHYSICAL',
  PHYSICAL: 'PHYSICAL'
};

export const giftCardMallAmounts = [15, 25, 50, 100, 200, 250, 500, 1000, 2000];

export const CUSTOM_INPUT = 'custom';

export const URL = {
  cashStarLLC: 'https://homedepot.semi.cashstar.com/store',
  cashStarProd: 'https://homedepot.cashstar.com/store',
  storeLocator: 'https://www.homedepot.com/l/search/'
};

export const newRelicMask = {
  message: '#####',
  senderName: '#####',
  recipientName: '#####',
  recipientEmail: '#####'
};

// eslint-disable-next-line max-len
export const giftCardPinImgUrl = 'https://secure2.homedepot.com/hdus/en_US/DTCCOM/common/giftcard/Images/WhereDoIFindPIN-newCardV4-withoutTitle.jpg';

export const staticPageUrls = {
  home: {
    url: '/',
    name: 'Home',
    label: 'home'
  },
  landing: {
    url: '/c/gift-cards',
    name: 'Gift Cards',
    label: 'landing'
  },
  thirdParty: {
    url: '/gift-cards/specialty-cards',
    name: 'Specialty Gift Cards',
    label: 'specialty-cards'
  }
};
export const NAME_PATTERN_REGEX = /^[A-Za-z0-9][A-Za-z0-9 -]*$/;
export const MESSAGE_PATTERN_REGEX = /^[A-Za-z0-9][A-Za-z0-9\\/.,!'\s-’]*$/;
export const MAX_NAME_LENGTH = '250';

export const FEATURE_SWITCH_NAMES = {
  DISABLE_GIFT_CARD_PURCHASE: 'disableGiftCardPurchase'
};

export const crateCardImg = 'https://assets.thdstatic.com/images/v1/hd_giftcard_topsellers/giftcard_crate.png';
